import React, { useContext, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import './whatscoveredpopup.scss';
import { useGetWhatIsCoveredQuery } from '../../../data/kontentAi';
import { FeatureFlagContext } from '../../../contextProviders/featureFlagContext';
import { WHATS_COVERED_SECTION } from '../../../constants/cmsCodeName';
import { WhatsCoveredSection } from './Sections/whatsCovered/WhatsCoveredSection';
import { WhatsNotCoveredSection } from './Sections/whatsNotCovered/WhatsNotCoveredSection';
import { RoutineCareSection } from './Sections/routineCare/RoutineCareSection';
import { BoosterCareSection } from './Sections/boosterCare/BoosterCareSection';
import { DisclaimerSection } from './Sections/disclaimer/DisclaimerSection';

export const WhatsCoveredPopup = forwardRef(
  (
    {
      isOpen,
      onClose = () => {},
      dynamicValue = {},
      cmsTags = {},
      dropdownField,
      planType,
      onHandlePrint,
      expandAllAccordion
    },
    ref
  ) => {
    const { cspConfiguration } = useContext(FeatureFlagContext);
    const isKontentAiPreviewEnabled = cspConfiguration?.IsKontentAIPreviewEnabled || false;
    const { data: whatsCoveredContent } = useGetWhatIsCoveredQuery({
      planType,
      policyCover: dropdownField,
      previewEnabled: isKontentAiPreviewEnabled
    });

    if (!whatsCoveredContent?.flatFields?.length) return null;

    const whatsCovered = whatsCoveredContent.flatFields.filter(
      (item) => item.section === WHATS_COVERED_SECTION.WHATS_COVERED
    );
    const whatsNotCovered = whatsCoveredContent.flatFields.filter(
      (item) => item.section === WHATS_COVERED_SECTION.WHATS_NOT_COVERED
    );
    const routineCare = whatsCoveredContent.flatFields.filter(
      (item) => item.section === WHATS_COVERED_SECTION.ROUTINE_CARE
    );
    const boosterCare = whatsCoveredContent.flatFields.filter(
      (item) => item.section === WHATS_COVERED_SECTION.BOOSTER_CARE
    );
    const disclaimer = whatsCoveredContent.flatFields.filter(
      (item) => item.section === WHATS_COVERED_SECTION.DISCLAIMER
    );

    return (
      <Modal
        size="small"
        open={isOpen}
        customCssClass="whatsCoveredPopup"
        isContentScrollable
        onClose={onClose}
        header={<h2 className="modal-title">{`${dynamicValue?.policyName} for ${dynamicValue?.animalName}`}</h2>}
        footer={
          <button
            type="button"
            className="button secondary"
            onClick={onHandlePrint}
          >
            Print
          </button>
        }
        showFooterDivider
      >
        <div
          className="whatsCoveredPopup mypets-whatscovered"
          ref={ref}
        >
          <div className="mypets-accordions">
            {whatsCovered?.length > 0 && (
              <WhatsCoveredSection
                whatsCoveredContent={whatsCovered}
                dynamicValue={dynamicValue}
                cmsTags={cmsTags}
                dropdownField={dropdownField}
                forceExpand={expandAllAccordion}
              />
            )}

            {whatsNotCovered?.length > 0 && (
              <WhatsNotCoveredSection
                whatsNotCoveredContent={whatsNotCovered}
                dynamicValue={dynamicValue}
                dropdownField={dropdownField}
                forceExpand={expandAllAccordion}
                cmsTags={cmsTags}
              />
            )}

            {routineCare?.length > 0 && (
              <RoutineCareSection
                routineCareContent={routineCare}
                dynamicValue={dynamicValue}
                dropdownField={dropdownField}
                forceExpand={expandAllAccordion}
                cmsTags={cmsTags}
              />
            )}

            {boosterCare?.length > 0 && (
              <BoosterCareSection
                boosterCareContent={boosterCare}
                dynamicValue={dynamicValue}
                dropdownField={dropdownField}
                forceExpand={expandAllAccordion}
                cmsTags={cmsTags}
              />
            )}

            {disclaimer?.length > 0 && (
              <DisclaimerSection
                disclaimerContent={disclaimer}
                cmsTags={cmsTags}
              />
            )}
          </div>
        </div>
      </Modal>
    );
  }
);

WhatsCoveredPopup.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  planType: PropTypes.string,
  /* eslint-disable react/forbid-prop-types */
  dynamicValue: PropTypes.object,
  dropdownField: PropTypes.object,
  cmsTags: PropTypes.object,
  /* eslint-enable react/forbid-prop-types */
  onHandlePrint: PropTypes.func,
  expandAllAccordion: PropTypes.bool
};

WhatsCoveredPopup.defaultProps = {
  isOpen: false,
  dynamicValue: {},
  cmsTags: {},
  onClose: () => {},
  planType: '',
  dropdownField: {},
  onHandlePrint: () => {},
  expandAllAccordion: false
};

export default WhatsCoveredPopup;
